import classNames from 'classnames'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLandingCourses } from '../../modules/apis/student/landing'
import { useOpenMaterialPopup } from '../../modules/hooks/common/useOpenMaterialPopup'
import CategoryTabs from '../tab/CategoryTabs'
import PacketCardNew from './PacketCardNew'
import QuadSlider from './QuadSlider'

const PacketCardNewTab: React.FC<any> = ({ children, ...props }) => {
  const MATERIAL_FREE_TALKING_ID = 'freetalking_section'
  const { md, xl, mobile, isModal, lg, slides = 4 } = props

  const router = useRouter()
  const showMaterialPopup = useOpenMaterialPopup()
  const [activeId, setActiveId] = useState(0) //심층토론
  const { data } = useLandingCourses()

  useEffect(() => {
    const load = (data) => {
      if (router.asPath.endsWith(MATERIAL_FREE_TALKING_ID)) {
        const lastId = data.categories.length - 1
        setActiveId(lastId)
      } else {
        setActiveId(0)
      }
    }
    if (data?.success) {
      load(data)
    }
  }, [data, router.asPath])

  return (
    <div>
      {/* TAB */}
      <div className="mb-[16px] flex justify-center">
        <CategoryTabs
          categories={data?.categories?.map((item, i) => {
            return {
              id: i,
              title: item.title,
            }
          })}
          activeTab={activeId}
          setActiveTab={setActiveId}
          md
        />
      </div>
      {/* ------ */}
      {/* SLIDER */}
      {/* ------ */}
      <div
        className={classNames(
          classNames(' mb-16 cursor-pointer', mobile ? '-ml-20 -mr-20' : ''),
          isModal && 'modal-tab'
        )}
      >
        <QuadSlider>
          {data?.categories[activeId]?.courses?.map((packet, i) => (
            <div key={i} onClick={(e) => showMaterialPopup(e, packet.id)} className="px-10">
              <PacketCardNew item={packet} landing={true} />
            </div>
          ))}
        </QuadSlider>
      </div>
    </div>
  )
}

export default PacketCardNewTab
